import { render } from "./OpenDockIcon16.vue.js?vue&type=template&id=8b55298e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./OpenDockIcon16.vue?vue&type=template&id=8b55298e"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__